import "./App.css";
import JumboApp from "@jumbo/components/JumboApp";
import JumboDialog from "@jumbo/components/JumboDialog";
import JumboDialogProvider from "@jumbo/components/JumboDialog/JumboDialogProvider";
import JumboTheme from "@jumbo/components/JumboTheme";
import JumboRTL from "@jumbo/JumboRTL/JumboRTL";
import Div from "@jumbo/shared/Div";
import {CircularProgress} from "@mui/material";
import {SnackbarProvider} from "notistack";
import React, {Suspense} from "react";
import {QueryClient, QueryClientProvider} from "react-query";
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import JumboAuthProvider from "../@jumbo/components/JumboAuthProvider/JumboAuthProvider";
import AppLayout from "./AppLayout";
import AppProvider from "./AppProvider";
import AppRoutes from "./AppRoutes";
import {config} from "./config/main";
import configureStore, {history} from "./redux/store";
import "react-toastify/dist/ReactToastify.css";
import InActivePopup from "./components/InActivePopup";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
});

const store = configureStore();

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <BrowserRouter history={history}>
                    <AppProvider>
                        <JumboApp activeLayout={config.defaultLayout}>
                            <JumboTheme init={config.theme}>
                                <JumboRTL>
                                    <JumboDialogProvider>
                                        <JumboDialog />
                                        <SnackbarProvider
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "right"
                                            }}
                                            maxSnack={3}
                                        >
                                            <JumboAuthProvider>
                                                <Div
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <AppLayout>
                                                        <Suspense
                                                            fallback={
                                                                <Div
                                                                    sx={{
                                                                        display: "flex",
                                                                        width: "100%",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        height: "100%"
                                                                    }}
                                                                >
                                                                    <CircularProgress />
                                                                </Div>
                                                            }
                                                        >
                                                            <ToastContainer autoClose={false} />
                                                            <InActivePopup />
                                                            <AppRoutes />
                                                        </Suspense>
                                                    </AppLayout>
                                                </Div>
                                            </JumboAuthProvider>
                                        </SnackbarProvider>
                                    </JumboDialogProvider>
                                </JumboRTL>
                            </JumboTheme>
                        </JumboApp>
                    </AppProvider>
                </BrowserRouter>
            </Provider>
        </QueryClientProvider>
    );
}

export default App;